import React, { useEffect, useState } from "react";
import { useLang } from "@/context/LangContext";

const calc = (end) => {
  const diff = Math.max(0, new Date(end).getTime() - Date.now());
  return {
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
    over: diff <= 0,
  };
};

export const Countdown = ({ endsAt, className = "", testId }) => {
  const { t } = useLang();
  const [tl, setTl] = useState(() => calc(endsAt));

  useEffect(() => {
    const id = setInterval(() => setTl(calc(endsAt)), 1000);
    return () => clearInterval(id);
  }, [endsAt]);

  if (tl.over) return null;
  const cell = (v, label) => (
    <span className="inline-flex items-baseline gap-0.5">
      <span className="font-medium tabular-nums">{String(v).padStart(2, "0")}</span>
      <span className="text-[10px] opacity-70">{label}</span>
    </span>
  );

  return (
    <span data-testid={testId} className={`inline-flex items-center gap-2 tabular-nums ${className}`}>
      {tl.d > 0 && cell(tl.d, t("cd.d"))}
      {cell(tl.h, t("cd.h"))}
      {cell(tl.m, t("cd.m"))}
      {cell(tl.s, t("cd.s"))}
    </span>
  );
};
